module.exports = __webpack_public_path__ + "static/media/5.5adf11d9.jpg";